/**
 * Client-safe environment variables.
 * These are "publishable" keys designed to be exposed in client-side code.
 * DO NOT add secret/private API keys here!
 */
import { runningServerSide } from '@benzinga/utils';

// Publishable keys (designed to be public)
export const STRIPE_PUBLISHABLE_KEY =
  process.env.NODE_ENV === 'production' ? 'pk_live_jaMpv6EMQhvjzDbiITCMQnjB' : 'pk_test_cKYZbepiuYLumURkRervARLQ';

export const CHARGEBEE_PUBLISHABLE_KEY =
  process.env.NODE_ENV === 'production'
    ? 'live_s2meQ2VUojWom2IppJ3cfbfrmo9bPnfW'
    : 'test_ujsqcH8bbHZoedgcVtKcoySLsImSDjYl';

// Intercom messenger app id — the public per-workspace embed id (same across envs).
export const INTERCOM_APP_ID = 'ez0ugkdw';

// Public URLs and API roots
export const DATAAPI_ROOT = 'https://data-api-next.benzinga.com/rest/';
export const NEWSAPI_ROOT = 'https://api.benzinga.com/api/v2/news';
export const CALENDARSAPI_ROOT = 'https://api.benzinga.com/api/v2/calendar';

const getBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  let baseUrl = 'https://www.benzinga.com';
  if (process.env.NODE_ENV === 'development') {
    baseUrl = 'http://local.benzinga.com:3000';
    if (process.env.HTTPS === 'true' && runningServerSide()) return 'https://local.benzinga.com:3000';
    if (process.env.HTTPS === 'true') return 'https://local.benzinga.com:3000';
  }
  return baseUrl;
};
export const BASE_URL = getBaseUrl();
